// import config from '../config';
// import { isFeatureFlagEnabled } from './localStorage';
import { hasPremiumMembership } from './user';
import { types as sdkTypes } from './sdkLoader';
import {
  calculateGuestLiabilityProtectionAmount,
  getGuestLiabilityProtectionSubtotalAmount,
  LINE_ITEM_GUEST_LIABILITY_PROTECTION,
} from './types';

const { Money } = sdkTypes;

export const GLP_SELECTION = {
  YES: 'yes',
  NO: 'no',
  LT_PLUS: 'ltPlus',
};

export const isGuestLiabilityProtectionEnabled = () => true;
// isFeatureFlagEnabled(config.featureFlags.GUEST_LIABILITY_PROTECTION, user);

export const isGuestLiabilityProtectionLocked = user =>
  isGuestLiabilityProtectionEnabled(user) && hasPremiumMembership(user);

/**
 * Normalizes persisted/form values to a GLP selection string.
 * Legacy boolean values from phase 1 are mapped to yes/no.
 */
export const normalizeGlpSelection = value => {
  if (value === true || value === GLP_SELECTION.YES) {
    return GLP_SELECTION.YES;
  }

  if (value === false || value === GLP_SELECTION.NO) {
    return GLP_SELECTION.NO;
  }

  if (value === GLP_SELECTION.LT_PLUS) {
    return GLP_SELECTION.LT_PLUS;
  }

  return undefined;
};

/**
 * Whether the booking should include a paid Guest Liability Protection line item.
 * LT+ selection is handled separately via subscription creation (phase 2).
 */
export const isGlpIncludedInTransaction = selection =>
  normalizeGlpSelection(selection) === GLP_SELECTION.YES;

export const isGlpLtPlusSelection = selection =>
  normalizeGlpSelection(selection) === GLP_SELECTION.LT_PLUS;

/**
 * Resolves Guest Liability Protection for checkout.
 * Returns undefined when the feature is disabled (no checkout state).
 * LT+ members are always included; non-members must make an explicit selection.
 */
export const getGuestLiabilityProtectionValue = (user, persistedValue) => {
  if (!isGuestLiabilityProtectionEnabled(user)) {
    return undefined;
  }

  if (hasPremiumMembership(user)) {
    return GLP_SELECTION.YES;
  }

  return normalizeGlpSelection(persistedValue);
};

export const requiredGlpSelection = message => value => {
  const normalized = normalizeGlpSelection(value);
  return normalized ? undefined : message;
};

/**
 * Calculates the Guest Liability Protection fee for display (checkout preview).
 */
export const calculateGlpProtectionCost = (transaction, currency = 'USD') => {
  const lineItems = transaction?.attributes?.lineItems || [];
  const protectionLineItem = lineItems.find(
    item => item.code === LINE_ITEM_GUEST_LIABILITY_PROTECTION && !item.reversal
  );

  if (protectionLineItem?.lineTotal) {
    return protectionLineItem.lineTotal;
  }

  const subtotalAmount = getGuestLiabilityProtectionSubtotalAmount(lineItems);
  const protectionAmount = calculateGuestLiabilityProtectionAmount(subtotalAmount);

  return new Money(protectionAmount, currency);
};
